module.exports = __webpack_public_path__ + "img/T2A_rc_19.07e90ff8.png";